import type { OtaReleaseChannelId } from './types';

/** Release channels (device routing ladder). Alpha may be added later. */
export const OTA_RELEASE_CHANNEL_ORDER: readonly OtaReleaseChannelId[] = [
  'beta',
  'general',
] as const;

export const OTA_RELEASE_CHANNEL_LADDER = OTA_RELEASE_CHANNEL_ORDER;

export function channelLabel(id: OtaReleaseChannelId): string {
  switch (id) {
    case 'beta':
      return 'Beta';
    case 'general':
      return 'General release';
  }
}

/** Card title on the Release Channels page. */
export function channelCardTitle(id: OtaReleaseChannelId): string {
  return id === 'beta' ? `🧪 ${channelLabel(id)}` : channelLabel(id);
}

export function isBetaReleaseChannel(id: OtaReleaseChannelId): boolean {
  return id === 'beta';
}

/** Gradual exposure rollout applies only to general release. */
export function hasGradualRollout(id: OtaReleaseChannelId): boolean {
  return id === 'general';
}

export function channelBadgeTone(id: OtaReleaseChannelId): 'warning' | 'info' {
  return id === 'beta' ? 'warning' : 'info';
}

export function channelTableBadgeLabel(id: OtaReleaseChannelId): string {
  return id === 'beta' ? '🧪 Beta' : 'General';
}
